import React from 'react';
import { Navigation, NavigationContent } from 'COMPONENTS/ui/Navigation';
import IMGLogo from 'ASSETS/logo-v1.svg';
import NavMenu from './NavMenu/NavMenu';
import UserMenu from './UserMenu/UserMenu';
import './MainLayout.less';

const MainLayoutNavBar = () => (
  <Navigation>
    <NavigationContent position="left">
      <div className="nav-logo">
        <IMGLogo width="120" height="30" className="logo" />
      </div>
    </NavigationContent>
    <NavigationContent className="nav-content">
      <NavMenu />
    </NavigationContent>
    <NavigationContent position="right">
      <UserMenu />
    </NavigationContent>
  </Navigation>
);

export default MainLayoutNavBar;



// WEBPACK FOOTER //
// ./src/components/Layout/Main/MainLayoutNavBar.js